// @ts-strict-ignore
/** @jsx jsx */
import { removeWhitespaceAndSpecialChars } from '@h/commons'
import loadable from '@loadable/component'
import { jsx } from 'theme-ui'
import Accordion from '../platinum-modules/accordion'
const DefaultAccordion = loadable(
  () => import('@uswitch/ev-components/lib/components/compounds/accordion'),
)
const NavAccordion = loadable(() => import('./nav-accordion.connected'))
const PlatinumAccordion = loadable(() => import('../platinum-modules/types-of-cards-accordion'))

export default (props) => {
  if (props?.variant === 'dropdown') {
    return <NavAccordion {...props} />
  } else if (props?.variant === 'desktopCards') {
    return (
      <div id={removeWhitespaceAndSpecialChars(props.name)}>
        <PlatinumAccordion {...props} />
      </div>
    )
  } else if (props?.variant === 'platinum') {
    return (
      <div className='NewSectionWrapper'>
        <div className='PlatinumWrapper'>
          <Accordion {...props} />
        </div>
      </div>
    )
  } else {
    return (
      <div id={removeWhitespaceAndSpecialChars(props.name)}>
        <DefaultAccordion {...props} />
      </div>
    )
  }
}
